import { render, staticRenderFns } from "./WSurveyAbout.vue?vue&type=template&id=1ab90f41&"
import script from "./WSurveyAbout.vue?vue&type=script&lang=ts&"
export * from "./WSurveyAbout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports